// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export {
  Choice as CheckboxChoice,
  Config as CheckboxConfig,
  checkbox,
} from "./customizedCheckboxPrompt";
export { Choice as SelectChoice, Config as SelectConfig, select } from "./customizedListPrompt";
